module.exports = __webpack_public_path__ + "img/gas.e63cca5.jpg";